
import React from "react";
import { Avatar } from "@material-ui/core";
import store from "redux/Store";

const getSharedUsers = (classes, data, allUsers) => {
  const {
    orgRuntime: {
      runtime: {
        _mlCfSharePermissionOptions
      }
    } 
  } = store.getState();

  if (data && data.length)
{
  return (
    data && data.map((v) => {
      var orgUser = allUsers?.find((r) => r.externalRefId === v.id);
      return (
        <div className={classes.sharedUserList}>
          <Avatar
            alt={orgUser?.name}
            src={orgUser?.imageUrl}
            className={classes.smallAvatar}
          ></Avatar>
          <div className={classes.sharedUserListSinglePreview}>
            <div title={orgUser?.name + " " +  (orgUser?.bbcCompany || "") + " " + (orgUser?.bbcDepartment || "")} className={classes.sharedUserListName}>{orgUser?.name + " " +  (orgUser?.bbcCompany || "") + " " + (orgUser?.bbcDepartment || "")}</div>
          </div>
          <div title={_mlCfSharePermissionOptions.find(e => e.id == v.permission).name} className={classes.sharedUserPermission}>
          {_mlCfSharePermissionOptions.find(e => e.id == v.permission).name || ""}
          </div>
        </div>
      );
    })
  );
}
else{
  return <div className={classes.underConstructionMessage} >Not Shared</div>
}
};

export default ({ label, data, classes, allUsers }) => {
  return (
    <div className={classes.sharePlaylistUsers}>
      <div title={label} className={classes.sharePlaylistUsersLabel}>{label}</div>
      <div className={classes.sharedUserListPreview}>
      {getSharedUsers(classes, data, allUsers)}
      </div>
    </div>
  );
};